module.exports = __webpack_public_path__ + "img/emptyCart.fa1be2a6.svg";